import {makeActionCreator} from "../../utils";

export const REMARKS_DESCRIPTION_CHANGED = "REPORTS.REMARKS_DESCRIPTION.REMARKS_DESCRIPTION_CHANGED";

export const remarksDescriptionChanged = makeActionCreator(REMARKS_DESCRIPTION_CHANGED, "payload");
